type Wave = OscillatorType;

let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const AC =
    window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") void ctx.resume();
  return ctx;
}

function tone(freq: number, start: number, duration: number, type: Wave = "sine", volume = 0.14) {
  const audio = getCtx();
  if (!audio) return;
  const t = audio.currentTime + start;
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(volume, t + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);
  osc.connect(gain).connect(audio.destination);
  osc.start(t);
  osc.stop(t + duration + 0.02);
}

export const sounds = {
  /** Bright three-note chime when the test starts. */
  start() {
    tone(523.25, 0, 0.18, "triangle");
    tone(659.25, 0.09, 0.18, "triangle");
    tone(783.99, 0.18, 0.3, "triangle");
  },
  /** Short soft "pop" on every step forward. */
  tick() {
    tone(880, 0, 0.09, "sine", 0.12);
    tone(1318.5, 0.05, 0.1, "sine", 0.08);
  },
  /** Triumph fanfare when the recommendation is unlocked. */
  unlock() {
    tone(392, 0, 0.12, "square", 0.06);
    tone(523.25, 0.1, 0.12, "square", 0.06);
    tone(659.25, 0.2, 0.12, "square", 0.06);
    [783.99, 1046.5, 1318.5].forEach((f) => tone(f, 0.32, 0.7, "triangle", 0.1));
    tone(2093, 0.36, 0.4, "sine", 0.04);
  },
  /** Celebratory arpeggio when the result is revealed. */
  result() {
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => tone(f, i * 0.11, 0.35, "triangle", 0.13));
    tone(1567.98, 0.48, 0.5, "sine", 0.07);
  },
};
